<template>
  <div>
    <label for="id_key" class="block text-sm font-medium text-gray-700">
      {{ $t('actions.type') }}
    </label>
    <select
      name="key"
      required
      id="id_key"
      class="form-multiselect block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
      v-model="key"
      :disabled="this.initialValues.key != ''"
    >
      <option
        v-for="choice in this.KEY_CHOICES"
        v-bind:key="choice.key"
        :value="choice.key"
      >
        {{ choice.value }}
      </option>
    </select>
    <FormComponent
      v-if="key"
      :fields="this.FIELDS_PER_TYPE[key]"
      v-model="args"
    />
    <input type="hidden" name="args" :value="JSON.stringify(args)" />
  </div>
</template>

<script>
import FormComponent from './FormComponent';

export default {
  name: 'ActionsEditor',
  components: {
    FormComponent,
  },

  data() {
    return {
      key: this.initialValues.key,
      args: this.initialValues.args,
    };
  },
  computed: {
    KEY_CHOICES() {
      return [
        { key: '', value: '' },
        {
          key: 'core.actions.send_email',
          value: this.$t('actions.email.title'),
        },
        {
          key: 'core.actions.http_request',
          value: this.$t('actions.http.title'),
        },
      ];
    },
    FIELDS_PER_TYPE() {
      return {
        'core.actions.http_request': [
          { label: 'URL', name: 'url', type: 'text', required: true },
        ],
        'core.actions.send_email': [
          {
            label: this.$t('actions.email.email_address_recipient'),
            name: 'email_to',
            type: 'textarray',
            required: true,
          },
          {
            label: this.$t('actions.email.email_address_cc'),
            name: 'email_cc',
            type: 'textarray',
            required: false,
          },
          {
            label: this.$t('actions.email.email_address_bcc'),
            name: 'email_bcc',
            type: 'textarray',
            required: false,
          },
          {
            label: this.$t('actions.email.sender_name'),
            name: 'reply_to_field',
            type: 'text',
            explainer: this.$t('actions.email.sender_name_explainer'),
          },
          {
            label: this.$t('actions.email.custom_topic'),
            name: 'subject',
            type: 'text',
            explainer: this.$t('actions.email.custom_topic_explainer'),
          },
          {
            label: this.$t('actions.email.custom_message'),
            name: 'message',
            type: 'textarea',
            explainer: this.$t('actions.email.custom_message_explainer'),
          },
          {
            label: this.$t('actions.email.show_link_in_notification'),
            name: 'show_view_form_url',
            type: 'boolean',
            default: true,
          },
          {
            label: this.$t('actions.email.add_attachments'),
            name: 'add_attachments',
            type: 'boolean',
            default: false,
          },
        ],
      };
    },
  },
  props: {
    initialValues: Object,
  },
};
</script>
